import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons';
import * as React from 'react';
import { FontAwesomeIcon } from './helpers/FontAwesomeIcon';

export const MeterIcon = (props: { color?: string }) => {
  return (
    <FontAwesomeIcon icon={faTachometerAlt} color={props.color || 'black'} />
  )
}
